module.exports = __webpack_public_path__ + "img/apidays-hongkong-2022-logo.445aefbc.png";